import { Component, NgZone,Input,ViewChild ,} from '@angular/core';
import * as am4core from "@amcharts/amcharts4/core";
import { Router } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { AppDataServiceService } from './app-data-service.service';
/*import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";*/

//am4core.useTheme(am4themes_animated);



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
  
})
export class AppComponent {
  update:boolean = false;
  joke:any;
  constructor(private router:Router, private swUpdate:SwUpdate, private getLivData:AppDataServiceService, ){
     router.navigate(['/login']);
    // })    
    // alert("Hllo");
    
  }
 
  ngOnInit() {
      this.getLivData.getChuckSillyJokes().subscribe( res=>{
      console.log(res);
      this.joke = res;
     // console.log(this.joke.value);
    })
}
 /* getData :string;
  getDtailsFlag : boolean =true;
 
  parentMethod(data){
    this.getData = data;
  }
  getCatRquest(data){
    this.getDtailsFlag = data;
  }
  closeEnergyDetails(data){
    this.getDtailsFlag = data;
  }
*/
reloadCache(){
  if(this.swUpdate.isEnabled){
    this.swUpdate.available.subscribe(() =>{
      if(confirm('New version Is available! Would You Like to update')){
        window.location.reload();
      }
    })
  }
}


}

